import React from "react";
import { makeStyles } from "@material-ui/styles";
import { DeviceList } from "./components";
import { Link as RouterLink } from "react-router-dom";

import { Button, SvgIcon } from "@material-ui/core";

import {PlusCircle as PlusCircleIcon } from "react-feather";
import { FormattedMessage } from "react-intl";
import { CONFIG_SETTINGS } from 'config.js';


const Devices = (props) => {
  const classes = useStyles();

  let deviceListRowsPerPage = localStorage.getItem(CONFIG_SETTINGS.DeviceListRowsPerPage) || 10;

  return (
    <div className={classes.root}>
      <div className={classes.row}>
        <span className={classes.spacer} />
        <Button
          color="primary"
          variant="contained"
          size="large"
          component={RouterLink} to={`/devices/add`}
        >
          <SvgIcon fontSize="small" className={classes.actionIcon}>
            <PlusCircleIcon />
          </SvgIcon>
          <FormattedMessage id="device_add_device" />
        </Button>
      </div>

      <div className={classes.content}>
        <DeviceList DeviceListRowsPerPage={deviceListRowsPerPage} />
      </div>
    </div>
  );
};

export default Devices;


const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
  },
  row: {
    height: "42px",
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(1),
  },
  spacer: {
    flexGrow: 1,
  },
  actionIcon: {
    marginRight: theme.spacing(1)
  }
}));